import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import BackButton from 'components/BackButton';

type NavigationHeaderProps = {
  onBack?: () => void;
};

const NavigationHeader: FC<NavigationHeaderProps> = ({ onBack }) => (
  <Box marginBottom="space-32">
    <BackButton onClick={onBack} />
  </Box>
);

export default NavigationHeader;
